import { useGoogleMap } from '@react-google-maps/api'
import { useEffect, useRef } from 'react'

interface MapControlProps {
  position: keyof typeof google.maps.ControlPosition
}

const MapCustomControls = ({
  position,
  children
}: React.PropsWithChildren<MapControlProps>) => {
  const map = useGoogleMap()
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (map?.controls && ref) {
      map.controls[google.maps.ControlPosition[position]]?.push(
        ref.current as HTMLElement
      )
    }
  }, [map, position, ref])
  return (
    <div className='bg-white rounded-md p-2 mt-2.5 mr-2.5' ref={ref}>
      {children}
    </div>
  )
}

export default MapCustomControls
